import { InReadIMobileAdContainer } from './in-read-i-mobile-ad-container';
import type { InReadAdContainerProps } from './types';

export const InReadAdContainer = ({
  canShowGoogleAd,
  adIndex,
  ...props
}: InReadAdContainerProps) => {
  return (
    <InReadIMobileAdContainer
      adIndex={adIndex}
      canShowGoogleAd={canShowGoogleAd}
      {...props}
    />
  );
};
